import { CategoryConfig } from '../types/CardCategory';

export const CATEGORY_CONFIGS: CategoryConfig[] = [
    { id: 'Students', label: 'Students', icon: 'SchoolSharp' },
    { id: 'Services', label: 'Services', icon: 'CalendarMonthSharp' },
    { id: 'Academics', label: 'Academics', icon: 'Spellcheck' },
    { id: 'Match', label: 'Match', icon: 'LocalAtmSharp' },
    { id: 'Texting', label: 'Texting', icon: 'PhonelinkRingSharp' },
    { id: 'System', label: 'System', icon: 'SettingsSharp' },
];
